import React from "react";
import { Github, Linkedin, Dribbble } from "lucide-react";
import { Link } from "@/components/common/Link";
import { NavigationMenu, NavigationMenuList, NavigationMenuItem, NavigationMenuLink } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function VerticalMenu({
  title
}: {
  title: string;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  return <div className="flex flex-col gap-8">
      <h3 className="font-black uppercase tracking-[0.25em] text-[11px] text-[#3CC5F3]">
        {title}
      </h3>
      {loading ? <div className="flex flex-col gap-4">
          {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="h-3 w-20 bg-[#3CC5F3]/10 animate-pulse rounded-full" />)}
        </div> : <NavigationMenu viewport={false} className="max-w-full justify-start">
          <NavigationMenuList className="flex-col items-start space-y-4 space-x-0">
            {menuItems.map((item, i) => <NavigationMenuItem key={item.id} className="w-full" data-index={i}>
                <NavigationMenuLink asChild className="h-auto w-full p-0 hover:bg-transparent focus:bg-transparent justify-start">
                  <Link to={item.href || "#"} className="group flex items-center gap-2 text-white/40 hover:text-white transition-all duration-300 font-semibold font-sans text-sm">
                    <span className="h-px w-0 bg-[#3CC5F3] transition-all duration-300 group-hover:w-4 shadow-[0_0_10px_rgba(60,197,243,0.8)]" />
                    {item.label}
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>)}
          </NavigationMenuList>
        </NavigationMenu>}
    </div>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true
  });
  return <footer ref={ref} id="footer" className={`dark bg-[#0D1B2A] text-white font-sans py-24 relative overflow-hidden transition-all duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      {}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-[#3CC5F3]/40 to-transparent" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-32 bg-[#3CC5F3]/5 blur-[120px] pointer-events-none" />
      
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 md:gap-8">
          
          {}
          <div className="flex flex-col gap-10 md:col-span-4">
            <Link to="/HomePage" className="block w-fit group">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612503/img/pocket_broker_logo.png" alt="Pocket Broker" className="h-7 w-auto object-contain transition-transform duration-500 group-hover:scale-105" />
            </Link>
            <div className="text-white/40 leading-relaxed font-medium text-sm max-w-xs">
              <p className="mb-2">© {new Date().getFullYear()} Pocket Broker.</p>
              <p className="font-extrabold text-white/80 tracking-tight text-base">
                AI-Powered Commercial Real Estate.
              </p>
              <div className="mt-10 inline-flex items-center gap-3 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-md">
                <span className="relative flex size-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#3CC5F3] opacity-75"></span>
                  <span className="relative inline-flex rounded-full size-2 bg-[#3CC5F3]"></span>
                </span>
                <p className="opacity-80 uppercase tracking-[0.2em] text-[10px] font-black text-[#3CC5F3]">
                  Free to tenants always
                </p>
              </div>
            </div>
          </div>

          {}
          <div className="md:col-span-2">
            <MenuProvider menu_id="40">
              <VerticalMenu title="Platform" />
            </MenuProvider>
          </div>

          <div className="md:col-span-2">
            <MenuProvider menu_id="41">
              <VerticalMenu title="Company" />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-8 md:col-span-4 md:items-end">
            <div className="flex flex-col gap-8 w-full md:max-w-[280px]">
              <h3 className="font-black uppercase tracking-[0.25em] text-[11px] text-[#3CC5F3] md:text-right">
                Built In Phoenix
              </h3>
              <div className="flex gap-4 md:justify-end">
                {[{
                icon: Github,
                href: "https://github.com",
                label: "Phoenix"
              }, {
                icon: Linkedin,
                href: "https://linkedin.com",
                label: "Arizona"
              }, {
                icon: Dribbble,
                href: "https://dribbble.com",
                label: "USA"
              }].map((social, i) => <Link key={i} data-index={i} to={social.href} newTab className="group relative size-11 flex items-center justify-center rounded-xl bg-white/5 border border-white/10 text-white/40 hover:text-[#3CC5F3] hover:border-[#3CC5F3]/40 transition-all duration-500 overflow-hidden" aria-label={social.label}>
                    <div className="absolute inset-0 bg-gradient-to-br from-[#3CC5F3]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                    <social.icon className="size-5 relative z-10 transition-transform duration-500 group-hover:scale-110" />
                  </Link>)}
              </div>
              <p className="text-[11px] text-white/30 uppercase tracking-widest font-black leading-relaxed md:text-right">
                Modernizing the industrial <br /> landscape through voice AI.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}